export const getFirstNameFromDisplayName = (display: string) => {
  if (!display) {
    return '';
  }
  return display.split(',')[0].split(' ')[0];
};

export const initialsFromName = (name: string) => {
  const initials = name
    .split(',')[0] // remove the ", patient" or ", Jr." etc.
    .split(' ') // make an array of the separate names
    .map((word) => word[0]) // iterate over each name and make an array of each first letter
    .join('') // join the first letters into a single string
    .toUpperCase(); // ensure all letters are uppercase

  return initials.length > 1 ? initials[0] + initials[initials.length - 1] : initials[0]; // ensure no more than 2 letters (most allowed by Spark)
};

export const formatLocalUrlTemplate = (urlTemplate: string) => {
  const { protocol, hostname } = (typeof window !== 'undefined' && window.location) || { protocol: '', hostname: '' };
  if (urlTemplate) {
    return `${urlTemplate?.replace('{protocol}', protocol).replace('{hostname}', hostname)}`;
  } else {
    return '';
  }
};

export const extractTargetFromUrl = (target: string) => {
  return target.split('/')[2]; //Extracts target url, for example logs-telehealth.px.athena.io from https://logs-telehealth.px.athena.io
};
